import { Stack } from '@mui/material'
import { form } from '../../formState'
import { useTexts } from './useTexts'

export function Password() {
  const texts = useTexts()

  const validationSummaryItems = form.useStandardPasswordValidations('new-password')

  return (
    <Stack spacing={2}>
      <form.Password
        name="new-password"
        testId="new-password"
        label={texts.label}
        placeholder={texts.placeholder}
        validateOn="blur change"
        errorVisibility="accent-only"
        textfieldProps={{
          autoComplete: 'new-password',
        }}
      />

      <form.ValidationSummary items={validationSummaryItems} mode="show-errors" />
    </Stack>
  )
}
